
<footer _ngcontent-c0="" id="site-footer">
    <div _ngcontent-c0="" class="ui basic segment container">
      <div _ngcontent-c0="" class="fcta-footer">
        <!-- <div _ngcontent-c0="" class="two column stackable ui grid">
          <div _ngcontent-c0="" class="column">
            <div _ngcontent-c0="" class="right menu">


              <div _ngcontent-c0="" class="segment">
                <div _ngcontent-c0="" class="ui container">
                  <img _ngcontent-c0="" src="/assets/images/coat-of-arms.png">
                  <span _ngcontent-c0="">© {{mesg | date: 'yyyy'}} Corporate Affairs Commission (CAC), Nigeria</span>
                </div>

              </div>


            </div>

          </div>
        </div> -->


        <div _ngcontent-c0="" class="column">
          <div _ngcontent-c0="" class="right menu" >
            <img _ngcontent-c0="" src="/assets/images/coat-of-arms.png">
            <span _ngcontent-c0="">© {{mesg | date: 'yyyy'}} Corporate Affairs Commission (CAC), Nigeria</span>

          </div>
        </div>
        <br>


        <div _ngcontent-c0="" class="column">
            <div _ngcontent-c0="" class="right menu" >
                <a _ngcontent-c0=""  class="footer-links" href="/privacy-policy">Privacy Policy</a>
                <b _ngcontent-c0="" class="footer-links-separator"> | </b>
                <a _ngcontent-c0="" class="footer-links" href="/refund-policy">Refunds, Cancellation and Return Policy</a>
                <b _ngcontent-c0="" class="footer-links-separator"> | </b>
                <a _ngcontent-c0="" class="footer-links" href="/terms">Terms of Use</a>
                <b _ngcontent-c0="" class="footer-links-separator"> | </b>
                <a _ngcontent-c0="" class="footer-links" href="/contact-us">Contact Us</a>
              </div>
        </div>
      </div>
    </div>
</footer>
